import * as React from "react";

const SvgDocumentsearch = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill={color} fillRule="nonzero">
      <path d="M13.293 3.293 12.586 4zM18.707 8.707 19.414 8zM10 20a1 1 0 1 0 0 2v-2ZM4 16a1 1 0 1 0 2 0H4ZM4.293 20.293a1 1 0 1 0 1.414 1.414l-1.414-1.414ZM7 4h5.586V2H7zM18 9.414V19h2V9.414zM12.586 4 18 9.414 19.414 8 14 2.586z" />
      <path d="M20 9.414A2 2 0 0 0 19.414 8L18 9.414h2ZM12.586 4 14 2.586A2 2 0 0 0 12.586 2v2ZM17 22a3 3 0 0 0 3-3h-2a1 1 0 0 1-1 1v2ZM6 5a1 1 0 0 1 1-1V2a3 3 0 0 0-3 3h2ZM17 20h-7v2h7zM6 16V5H4v11zM14 14a2 2 0 0 1-2 2v2a4 4 0 0 0 4-4h-2ZM10 14a2 2 0 0 1 2-2v-2a4 4 0 0 0-4 4h2ZM12 12a2 2 0 0 1 2 2h2a4 4 0 0 0-4-4v2ZM9.172 15.414l-4.88 4.879 1.415 1.414 4.879-4.879z" />
      <path d="M12 16a1.99 1.99 0 0 1-1.414-.586l-1.414 1.414A3.99 3.99 0 0 0 12 18v-2Z" />
      <path d="M10.586 15.414A1.99 1.99 0 0 1 10 14H8a3.99 3.99 0 0 0 1.172 2.828l1.414-1.414Z" />
    </g>
  </svg>
);

export default SvgDocumentsearch;
